module.exports = __webpack_public_path__ + "img/trash-icon.2415703a.svg";